//Login.js
import React from "react";
import { Form, Input, Button, message, Spin, Row, Col, Checkbox } from "antd";
import md5 from "js-md5";
import Config from "../config/Config";
import Widget from "../widget/Widget";
import WidgetAjax from "../widget/WidgetAjax";
import WidgetModal from '../widget/WidgetModal';
import ForgetPassword from './forgetPassword';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
import WidgetAES from '../widget/WidgetAES';
let path = Config.getBasePath();
let application = Config.getApplication();
React.Component.prototype.$md5 = md5;

class register extends React.Component {
  constructor(props) {
    super(props);

    let { switchType, setType } = this.props.location.state || {};
    this.state = {
      qrLoading: false,
      switchType: switchType || 1, //手机号注册 2找回密码
      setType,
      countdown: 0,
    };
    this.timer = null;
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    this.clearTimer();
  }

  // 清除定时器
  clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  requirement = () => {

    const onRequirement = (result, params) => {

      if (result.status === 0) {
        let password = result.password;

        let message = "密码中必须包含大小写字母、数字、特殊字符";

        let minLength = 10, maxLength = 20, complex = 2;

        if (password) {
          minLength = password.min_length;
          maxLength = password.max_length;

          complex = password.complex;


          switch (password.complex) {
            case 1:
            case "1":
              {
                message += "中的1项, "
                break;
              }
            case 2:
            case "2":
              {
                message += "中的2项, "
                break;
              }
            case 3:
            case "3":
              {
                message += "中的3项, "
                break;
              }
            case 4:
            case "4":
              {
                message += "中的4项, "
                break;
              }
            case 5:
            case "5":
              {
                message += "中的5项, "
                break;
              }
          }



          message += "长度至少" + minLength + "个字符，最多" + maxLength + "个字符!"
        }
        else {
          message = "密码中必须包含大小写字母、数字、特殊字符中的2项，长度至少8个字符，最多21个字符！"
        }


        this.setState({ requiredMessage: message, minLength: minLength, maxLength: maxLength, complex: complex });
      }
      else {

      }
    }

    WidgetAjax.ajax({ url: path + '/requirement', params: undefined, callback: onRequirement });
  }

  verificatePassword = (value) => {

    const { complex, minLength, maxLength } = this.state;

    // 1. 长度校验 
    if (value.length < minLength) {

      this.setState({ requiredMessage: '密码长度不能少于' + minLength + '个字符!' });

      return false;
    }
    if (value.length > maxLength) {

      this.setState({ requiredMessage: '密码长度不能多于' + maxLength + '个字符!' });

      return false;
    }

    // 2. 复杂度校验 
    let size = 0;
    let regex;
    regex = new RegExp('[A-Z]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[a-z]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[0-9]+');
    if (regex.test(value)) size++;

    regex = new RegExp('[.@$!%*#_~?&^]+');
    if (regex.test(value)) size++;

    if (size < complex) {

      this.setState({ requiredMessage: '密码中必须包含大写字母、小写字母、数字、特殊字符中' + complex + '项!' });

      return false;
    }
    return true;

  }




  validateCreditPassword = (rule, value, callback) => {

    if (value) {
      let regular1 = false, regular2 = false, regular3 = false
      // const passwordRegex1 = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{6,20}$/; // 密码正则表达式，6到20个字符，包含字母、符号和数字
      const passwordRegex2 = /^[A-Za-z0-9\d!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/; // 密码正则表达式，只包含字母、数字以及除空格外的标点符号
      const passwordRegex3 = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/; // 密码正则表达式，至少包含字母、数字和标点符号中的任意两种
      if (value.length > 6) //用户名 和 密码 不能一致
      {
        regular1 = true
      }
      if (passwordRegex2.test(value)) {
        regular2 = true
      }
      if (passwordRegex3.test(value)) {
        regular3 = true
      }
      if (regular1 && regular2 && regular3) {
        callback();
      }
      else {
        callback('密码格式不正确');
      }
      this.setState({ regular1, regular2, regular3 });

    } else {
      callback();
    }

  }

  mesCode = (CELL) => {
    const onSend = (res) => {
      if (res.status == 0) {
        this.startCountdown();
      } else {
        message.error("短信发送失败!请重试")
      }
    }
    WidgetAjax.ajax({ url: path + '/message/sms', params: { CELL }, callback: onSend });

  }

  handleClick = () => {
    const { CELL } = this.state;
    if (CELL && this.validatePhoneNumber(CELL)) {
      if (this.state.countdown === 0) {
        this.setState({ countdown: 120 });
        this.mesCode(CELL);

      }
    } else {
      message.error("手机号格式不正确!");
    }
  };

  // 开始倒计时
  startCountdown() {
    this.clearTimer();
    this.timer = setInterval(() => {
      const { countdown } = this.state;
      if (countdown > 0) {
        this.setState(prevState => ({
          countdown: prevState.countdown - 1
        }));
      } else {
        // 倒计时结束，清除定时器
        this.clearTimer();
      }
    }, 1000);
  }

  // 手机号格式校验函数
  validatePhoneNumber = (phone) => {
    // 使用正则表达式校验：11位数字，以1开头
    const regex = /^1\d{10}$/;
    return regex.test(phone);
  };


  register = () => {
    this.form.validateFields().then((value) => {
      if (!value?.CAPTCHA) return message.info("请输入短信验证码!");
      let params = {
        ...value,
        password: this.$md5("ES_6ps" + value?.newPassword + "_N3tM").toUpperCase(),
        confirmPassword: undefined,
        newPassword: undefined
      }

      const onRegister = (res) => {
        if (res.status == 0) {
          message.success("注册成功!");
          setTimeout(() => {
            this.props.history.push("/login");
          }, 2000);
        } else {
          message.error("注册失败!" + res.message)
        }
      }
      WidgetAjax.ajax({ url: path + '/applicant/register', params, callback: onRegister });
    })
  }

  /**
   * 验证手机号是否存在
   */
  verify = () => {
    const { CELL } = this.state;
    const regular = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/;
    if (!regular.test(CELL)) return
    const onVerify = (res) => {
      if (res.status == 0) {
        if (res.result == 1) { //存在的时候 弹窗
          this.setPwdRef.open();
        }
      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/verify', params: { type: "2", value: CELL }, callback: onVerify });
  }


  /**
 * switchType 注册1 找回密码2
 * setType:1 存在代表是新用户
 */
  setPwd = () => {
    this.setState({ switchType: 2, setType: 1 });
  }


  render() {

    let { qrLoading, switchType, countdown, setType = undefined ,checked} = this.state;

    let layout = { labelCol: { span: 5 }, wrapperCol: { span: 24 } };
    // 根据倒计时状态动态更新按钮文本
    const buttonText = countdown > 0
      ? `重新获取(${countdown}s)`
      : '免费获取';
    return (
      <div className="slg-login" component-data="register" >
        <Spin tip="正在注册..." spinning={qrLoading}>

          <div className="slg-login-bc">

            <div className="slg-reg-body">
              <div className="slg-reg-box">

                <div className="slg-reg-head">
                  <img className="slg-reg-logo" src={require("../img/pinzhunzhun/login/logo.png")} />
                  <div className="slg-reg-title">{switchType == 1 ? '手机号注册' : setType ? '设置密码' : '找回密码'}</div>
                </div>
                {
                  switchType == 1 ?

                    <div className="reg-form-box">
                      <Form {...layout} ref={ref => this.form = ref} >
                        <div className="form-item">
                          <Form.Item
                            name="CELL"
                            label="手机号"
                            rules={[
                              { required: true, message: '请输入手机号' },
                              {
                                pattern: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/,
                                message: '请输入有效的11位手机号'
                              }
                            ]} >
                            <Input
                              maxLength={11}
                              onBlur={this.verify}
                              onChange={(e) => { this.setState({ CELL: e.target.value }) }}
                              placeholder="请输入手机号"
                            />
                          </Form.Item>
                          <div className="reg_tips">
                            请输入11位手机号，仅支持大陆地区手机号。
                          </div>
                        </div>

                        <div className="form-item">
                          <Form.Item
                            label="密码"
                            name="newPassword" hasFeedback rules={[
                              { required: true, message: '请输入登录密码' },
                              { validator: this.validateCreditPassword }
                            ]}
                          >
                            <Input.Password placeholder="请输入登录密码" />
                          </Form.Item>
                          <div className="reg_tips">
                            密码由6-30位的英文字母、数字和特殊字符组成，必须包含数字、小写字母和大写字母
                          </div>
                        </div>

                        <div className="form-item">
                          <Form.Item
                            label="密码确认"
                            name="confirmPassword" dependencies={['newPassword']} hasFeedback
                            rules={[{ required: true, message: '请再次输入密码', },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('两次输入的密码不一致'));
                              },
                            }),
                            ]}
                          >
                            <Input.Password placeholder="请再次输入登录密码" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                          </Form.Item>
                          <div className="reg_tips">
                            请再次填写一遍密码，以辅助检测密码输入是否正确。
                          </div>
                        </div>


                        <Form.Item style={{ height: '33px', paddingLeft: "10px" }}>
                          <Row gutter={12}>
                            <Col span={16}>
                              <Form.Item
                                labelCol={{ span: 7 }}
                                label="短信验证码"
                                name="CAPTCHA"
                              // rules={[{ required: true, message: '请输入验证码' }]}
                              >
                                <Input placeholder="请输入短信验证" />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Button style={{ width: "100%" }}
                                onClick={this.handleClick}
                                disabled={countdown > 0}
                              >{buttonText}</Button>
                            </Col>
                          </Row>
                        </Form.Item>

                        <div className="reg-form-but">
                          <Form.Item
                            className="jtct"
                            name="check"
                            style={{ marginBottom: "24px" }}
                            rules={[
                              {
                                validator: (_, value) => {
                                  const { checked } = this.state;
                                  if (checked) {
                                    return Promise.resolve()
                                  } else {
                                    return Promise.reject(new Error('请勾选协议'))
                                  }
                                }
                              },
                            ]}
                          >
                            <Checkbox onChange={(e) => { this.setState({ checked: e.target.checked }) }} checked={checked} />
                            <span className="sg-check">已阅读并同意
                                 <a onClick={(e) => { e.stopPropagation(); window.open('/recruit/home/service-agreement', '_blank') }}>《聘准准用户服务协议》
                                    </a>及<a onClick={(e) => { e.stopPropagation(); window.open('/recruit/home/privacy-policy', '_blank') }}>《个人信息保护政策》</a></span>
                          </Form.Item>
                          <Button type="primary" style={{ height: "44px", marginBottom: "18px" }} block size="large" onClick={() => this.register()}> 注册</Button>
                          <div className="sf-page-tool-between">
                            <span className="sg-check">已有聘准准账号 <a onClick={() => { this.props.history.push("/login") }}>登录</a></span>
                            <span className="sg-check">忘记密码 <a onClick={() => this.setState({ switchType: 2 })}>找回</a></span>
                          </div>
                        </div>
                      </Form>
                    </div>
                    :
                    <ForgetPassword history={this.props?.history} />

                }


              </div>
            </div>
          </div>

          <WidgetModal options={{ title: '温馨提示', width: '448px', isCancel: false, isOk:false}} onRef={ref => this.setPwdRef = ref} >
            <div style={{ paddingTop: '20px' }}>您已是系统用户！</div>
          </WidgetModal>

        </Spin >



      </div >
    );
  }
}

export default register;
